import React from 'react'

const Separator = () => (
  <div className='height-50 bc-white-55 mx2 border-left' />
)

export default Separator
